import { render, staticRenderFns } from "./MedicalInformation.vue?vue&type=template&id=e04abc26&"
import script from "./MedicalInformation.vue?vue&type=script&lang=js&"
export * from "./MedicalInformation.vue?vue&type=script&lang=js&"
import style0 from "./MedicalInformation.vue?vue&type=style&index=0&id=e04abc26&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports